(function ($) {
  let cartIsLoading = false;

  // OPEN / CLOSE DRAWER
  $(document).on("click", "#drawer-toggle", function () {
    $('#menu-drawer').addClass('open');
    $('.custom_overlay').addClass('active');
  });

  $(document).on("click", "#drawer-close", function () {
    $('#menu-drawer').removeClass('open');
    $('.custom_overlay').removeClass('active');
  });

  // open cart drawer
  $(document).on("click", "#cart-toggle", function () {
    $('#cart-drawer').addClass('open');
    $('.custom_overlay2').addClass('active');
  });

  // close cart drawer
  $(document).on("click", "#cart-close, .cart_empty_button", function () {
    $('#cart-drawer').removeClass('open');
    $('.custom_overlay2').removeClass('active');
  });

  // click outside
  $(document).on('click', function (e) {
    if (cartIsLoading) return;
    if (!$(e.target).closest('#cart-drawer, #cart-toggle, #menu-drawer, #drawer-toggle').length) {
      $('#cart-drawer').removeClass('open');
      $('.custom_overlay2').removeClass('active');
      $('#menu-drawer').removeClass('open');
      $('.custom_overlay').removeClass('active');
    }
  });

  // Update cart (reload whole page after success)
  function updateCart(key, quantity, sellingPlan = null) {
    if (!key) {
      console.error('Missing line item key for updateCart');
      return $.Deferred().reject().promise();
    }

    const payload = { id: key, quantity: quantity };
    if (sellingPlan) payload.selling_plan = sellingPlan;

    cartIsLoading = true;
    $('div#cart_drawer_content').addClass('loading_hk');

    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify(payload),
      dataType: 'json',
      contentType: 'application/json'
    }).done(function () {
      location.reload(); // ✅ full page refresh instead of drawer refresh
    }).fail(function (xhr) {
      console.error('Cart update failed:', xhr);
      $('div#cart_drawer_content').removeClass('loading_hk');
      cartIsLoading = false;
    });
  }

  // quantity +/-
  $(document).on('click', '.quantity_plus', function (e) {
    e.preventDefault();

    const $wrap = $(this).closest('.cart_quantity_wrapper');
    const $input = $wrap.find('input.quantity_selector');
    if (!$input.length) return;

    let qty = parseInt($input.val(), 10) || 0;
    qty = qty + 1;
    $input.val(qty);

    const key = $input.data('key') || $wrap.closest('[data-key]').data('key');
    updateCart(key, qty);
  });

  $(document).on('click', '.quantity_minus', function (e) {
    e.preventDefault();

    const $wrap = $(this).closest('.cart_quantity_wrapper');
    const $input = $wrap.find('input.quantity_selector');
    if (!$input.length) return;

    let qty = parseInt($input.val(), 10) || 0;
    if (qty <= 1) return;
    qty = qty - 1;
    $input.val(qty);

    const key = $input.data('key') || $wrap.closest('[data-key]').data('key');
    updateCart(key, qty);
  });

  // typing change (debounced)
  let typingTimer;
  $(document).on('input', 'input.quantity_selector', function () {
    const $input = $(this);
    clearTimeout(typingTimer);
    typingTimer = setTimeout(function () {
      let qty = parseInt($input.val(), 10);
      if (isNaN(qty) || qty < 1) {
        qty = 1;
        $input.val(qty);
      }
      const key = $input.data('key') || $input.closest('[data-key]').data('key');
      updateCart(key, qty);
    }, 600);
  });

  // Add recommended product (reload after add)
  $(document).on("click", ".recommended_product_button", function (e) {
    e.preventDefault();
    const $btn = $(this).addClass("loading_hk");
    const id = $btn.attr("variant_id");
    const quantity = $btn.attr("quantity") || 1;

    $.post("/cart/add.js", { id: id, quantity: quantity }, function () {
      location.reload(); // ✅ reload full page after add
    }, "json").fail(function (xhr) {
      console.error('Add recommended product failed', xhr);
      $btn.removeClass("loading_hk");
    });
  });

  // Remove product (reload after remove)
  $(document).on('click', '.cart_item_single_right_remove', function (e) {
    e.preventDefault();
    const $btn = $(this);
    const key = $btn.closest('[data-key]').data('key');

    if (!key) {
      console.error('Missing line item key on remove button');
      return;
    }

    $btn.prop('disabled', true);
    updateCart(key, 0).always(function () {
      $btn.prop('disabled', false);
    });
  });

  function updateVh() {
    document.documentElement.style.setProperty('--real-vh', `${window.innerHeight}px`);
  }
  window.addEventListener('resize', updateVh);
  window.addEventListener('load', updateVh);

})(jQuery);

function updateLocalSubtotal() {
  let subtotal = 0;
  $('.cart_item_single').each(function () {
    const qty = parseInt($(this).find('.quantity_selector').val(), 10);
    const price = parseFloat($(this).data('price'));
    if (!isNaN(qty) && !isNaN(price)) {
      subtotal += qty * price;
    }
  });
  $('.cart_subtotal').text(`$${subtotal.toFixed(2)}`);
}
